// extracted by mini-css-extract-plugin
export var cardWrapper = "Card-module--card-wrapper--3XMAz";
export var iconWrapper = "Card-module--icon-wrapper--3PnbP";
export var icon = "Card-module--icon--2oICD";